module.exports = __webpack_public_path__ + "static/6-e829f491c8394c5c551fb0159e754120.png";